import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  root: (props) => ({
    minWidth: 'auto',
    width: 30,
    height: 30,
    padding: '2px',
    backgroundColor: `${(props as any).backgroundColor}`,
    borderRadius: '50%',
    [theme.breakpoints.down('md')]: {
      width: 25,
      height: 25,
    },
  }),
  icon: {
    color: theme.custom.darkBlue,
    transition: '.2s linear',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.3rem',
    },
  },
  up: {
    transform: 'rotate(180deg)',
  },
  down: {
    transform: 'rotate(0)',
  },
  left: {
    transform: 'rotate(90deg)',
  },
  right: {
    transform: 'rotate(-90deg)',
  },
}));
